import React from 'react'
import { render } from 'react-dom'
import { initFragmentOnClient } from 'lib/ssr-client-react'
import fragment from './index'
import { createLogger } from 'common/log'
import { getFragmentState } from '../../../lib/ssr-client'
import createCache from '@emotion/cache'
import { CacheProvider } from '@emotion/react'

const logger = createLogger('fragments/lastViewedProducts/client')
const fragmentName = 'lastViewedProducts'

// DO NOT CHANGE UNLESS YOU REALLY KNOW WHAT YOU ARE DOING
renderFragmentOnClient(fragment.Component, fragmentName)
if (module.hot) {
  module.hot.accept('./index', () => {
    logger.debug(`hot reloading ${fragmentName}`)
    const reload = require('./index').default
    initFragmentOnClient(reload.Component, fragmentName)
  })
}

function renderFragmentOnClient(Fragment, fragmentName, id) {
  const preloadedState = getFragmentState(id || fragmentName)
  const cache = createCache({ key: preloadedState.styleKey.toLowerCase() })
  const rootElement =
    document.getElementById('lastViewedProductsContainer') || document.getElementById('lastViewedProducts')

  render(
    <CacheProvider value={cache}>
      <Fragment {...preloadedState} />
    </CacheProvider>,
    rootElement
  )
}
